import { render, TemplateResult } from "lit-html";

export function renderAsChild(template: TemplateResult, target: HTMLElement) {
    const tempElement = document.createElement('div');
    render(template, tempElement);
    const child = tempElement.children[0];
    target.appendChild(child);
    return child;
}
